import { authorizationService } from "shared-auth";
import { FullPageSpinner } from "shared/modules/Common/FullPageSpinner";

const Logout = () => {
  authorizationService.signOutRedirect();

  return <FullPageSpinner />;
};

export default Logout;
